@switch (type) {
    @case ('href'){
        <a
            [routerLink]="routerLink"
            pButton
            [dt]="designToken"
            class="whitespace-nowrap">
            <span pButtonLabel>{{ label }}&nbsp;<i class="pi pi-angle-right"></i></span>
        </a>
    }
    @case ('button'){
        <p-button
            [fluid]="fluid"
            [label]="label"
            [dt]="designToken"
            [icon]="icon"
            (click)="onClick()"
            [disabled]="disabled"
            iconPos="right"
            class="tracking-wide whitespace-nowrap" />
    }
}
